export type WebappBrand = 'levelworks' | 'opus';

export const resolveWebappBrand = (brand: unknown): WebappBrand =>
  brand === 'opus' ? 'opus' : 'levelworks';
